export enum McamUdfId {
  Type = 'MCAMType',
  ApplicablePayments = 'ApplicableMCAMPayments',
}

export enum McamPaymentType {
  ResidentialAdmin = 'MCAM-S-Residential-Admin',
  ResidentialHostingCapacity = 'MCAM-S-Residential-Hosting-Capacity',
  CommercialAdmin = 'MCAM-S-Commercial-Admin',
  CommercialHostingCapacity = 'MCAM-S-Commercial-Hosting-Capacity',
}
